"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnchorButtonWrapper = exports.ButtonWrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const baseStyle = (0, styled_components_1.css) `
  display: flex;
  justify-content: space-between;
  align-items: center;

  height: 20px;
  min-width: 70px;
  padding: 8px 10px;
  border-radius: 5px;
  font-size: 15px;
  background: rgba(167, 182, 194, 0.3);
  color: #3c3c3c;
  white-space: nowrap;

  &:hover {
    background: rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: translateY(1px);
  }
`;
exports.ButtonWrapper = styled_components_1.default.button `
  ${baseStyle}
  cursor: pointer;
`;
exports.AnchorButtonWrapper = styled_components_1.default.a `
  ${baseStyle}
  text-decoration: none;

  & > * + * {
    margin-left: 5px;
  }
`;
